export default __webpack_public_path__ + "static/media/lost-in-space.74a9fddf.svg";